import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    IconButton,
    InputBase,
    Stack,
    Typography,
} from '@mui/material';
import type { DataCatalogFieldTip } from 'modules/datacatalog/types';
import { useState } from 'react';

import DataCatalogTextEditor from './DataCatalogTextEditor';

type TipItem = DataCatalogFieldTip & { id: string };

type FieldTipAccordionProps = {
    tip: TipItem;
    canEdit: boolean;
    onSave: (tip: TipItem) => void;
    onDelete: (tip: TipItem) => void;
};
const FieldTipAccordion = ({
    tip,
    canEdit,
    onSave,
    onDelete,
}: FieldTipAccordionProps) => {
    const [isExpanded, setExpanded] = useState<boolean>(false);
    const [isEditing, setIsEditing] = useState<boolean>(false);
    const [question, setQuestion] = useState<string>(tip.question);

    return (
        <Accordion
            key={tip.id}
            expanded={isExpanded}
            onChange={() => {
                if (!isEditing) setExpanded(!isExpanded);
            }}
        >
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                {isEditing ? (
                    <InputBase
                        value={question}
                        fullWidth
                        autoFocus
                        onClick={(e) => e.stopPropagation()}
                        onChange={(e) => {
                            setQuestion(e.target.value);
                        }}
                        sx={{ fontWeight: 500 }}
                    />
                ) : (
                    <Stack
                        direction="row"
                        sx={{
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            width: '100%',
                        }}
                    >
                        <Typography variant="body1">{tip.question}</Typography>
                        {canEdit && (
                            <Stack direction="row">
                                <IconButton
                                    size="small"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        setIsEditing(true);
                                        setExpanded(true);
                                    }}
                                >
                                    <EditIcon
                                        fontSize="small"
                                        color="primary"
                                    />
                                </IconButton>
                                <IconButton
                                    size="small"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        onDelete(tip);
                                        setIsEditing(false);
                                        setExpanded(false);
                                    }}
                                >
                                    <DeleteIcon
                                        fontSize="small"
                                        color="error"
                                    />
                                </IconButton>
                            </Stack>
                        )}
                    </Stack>
                )}
            </AccordionSummary>
            <AccordionDetails>
                <DataCatalogTextEditor
                    key={tip.id}
                    isEditable={isEditing}
                    content={tip.answer}
                    canEdit={canEdit}
                    onSave={(value) => {
                        onSave({ ...tip, answer: value, question });
                        setIsEditing(false);
                    }}
                />
            </AccordionDetails>
        </Accordion>
    );
};

export default FieldTipAccordion;
